module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row margin-b30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não, devido nossos planos serem pré-pagos, é necessário somente o pagamento de adesão e recarga.\n                Para saber mais sobre nossa tabela de recargas e tarifas, acesse:\n                "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'services'
      },
      "tag": "a"
    }
  }, [_vm._v("\n                  Recargas\n                ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Estamos presentes em 100% dos Estados com vias pedagiadas do Brasil. Para consultar a cobertura completa da Move Mais, acesse:\n                "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'range'
      },
      "tag": "a"
    }
  }, [_vm._v("\n                  Cobertura\n                ")])], 1)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "row margin-b30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Para Pessoa Física as recargas são múltiplas de R$50,00, enquanto que para Pessoa Jurídica,\n                os valores são múltiplos de R$ 500,00. Para verificar as formas de pagamento por plano, acesse:\n                "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'services'
      },
      "tag": "a"
    }
  }, [_vm._v("\n                  Serviços\n                ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Nos planos Pré-Pagos você recarrega sua conta Move Mais quando achar conveniente. A recarga pode ser\n                feita a qualquer momento, através do site Move Mais ou pelo App. A recarga será disponibilizada em\n                até 30 minutos em sua conta Move Mais. Para verificar a tabela de recarga, acesse:\n                "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'services'
      },
      "tag": "a"
    }
  }, [_vm._v("\n                  Serviços\n                ")])], 1)])]), _vm._v(" "), _vm._m(23)])]), _vm._v(" "), _vm._m(24)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("F.A.Q. (Perguntas Frequentes)")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n          Confira aqui as as respostas das perguntas mais frequentes:\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-line-purple margin-b20"
  }, [_c('p', {
    staticClass: "bold upper"
  }, [_vm._v("adesão")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Sou Pessoa física, existe cobrança de mensalidade?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Onde posso usar a Move Mais? Em qual cidade ou estado?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Quais são as vantagens que a Move Mais oferece?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Mais que um Sistema de Pagamento Automático de Pedágios, a Move Mais oferece um conjunto de serviços que\n                facilita a relação com o seu carro, onde você estiver. Através do Portal Move Mais ou do aplicativo para\n                smartphones (Android e IOS), você pode usufruir de todos os serviços que a Move Mais oferece, consultar o histórico\n                das passagens e transações, gerenciar sua conta e consultar seu saldo a qualquer hora e em qualquer lugar. Sem se\n                preocupar com mensalidades ou fidelidade, você escolhe um dos Planos Pré-pagos: Pré-pago Manual ou Pré-pago\n                Automático. E escolhe também um Valor de Recarga disponível. E contando sempre com a Central de Relacionamento,\n                "), _c('strong', [_vm._v("24 horas por dia e 7 dias por semana")]), _vm._v(".\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Quais as formas de pagamento disponíveis?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Para os Planos Pré-pagos a forma de pagamento disponível é com cartão de crédito.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              O meu saldo expira?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não expira e o saldo fica disponível em sua conta por tempo indeterminado ou até a próxima viagem.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Como eu sei a categoria do meu veículo?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                A categoria do veículo é definida pela quantidade de eixos que ele possui. Por exemplo, veículos com dois\n                eixos de rodagem simples (passeio e utilitários) correspondem à categoria 1, veículos com dois eixos de rodagem\n                dupla correspondem à categoria 2, veículos com três eixos de rodagem dupla correspondem à categoria 3, e assim por\n                diante. A categoria do seu veículo pode ser encontrada no documento CRLV. Para consultar as categorias completa de veículos, acesse:\n                "), _c('span', [_c('a', {
    staticClass: "link",
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/categoria-veiculos",
      "target": "_blank"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCategorias\n\t\t\t\t\t\t\t\t")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              O TAG poderá ser usada para verificar outros dados (velocidade e/ou documentação do veículo) para aplicação de multas?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não, o TAG é exclusiva para identificação e pagamento nas praças de pedágio conveniados à Move Mais.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Existe limite de veículos por contrato?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não temos limite mínimo, sempre que você quiser pode adicionar outros veículos em um só contrato.\n                Além disso, na Move Mais você pode ter vários contratos em seu nome, com opções de planos e veículos diferentes em cada um deles.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Na Move Mais existe cláusula de fidelidade?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não, em nossos planos Pré-pagos não existe cláusula de fidelidade, dando autonomia para encerrar o contrato quando preferir.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-b30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "plan-line-blue margin-b20"
  }, [_c('p', {
    staticClass: "bold upper"
  }, [_vm._v("tag")])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Recebi meu TAG. O que fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                O TAG é enviado bloqueada por motivo de segurança, neste caso basta acessar o site movemais.com\n                realizar a ativação ou entrar em contato através dos telefones 4000 2901 (Capitais e Regiões Metropolitanas)\n                e 0800 777 1022 (Demais Localidades). É de suma importância que o TAG seja desbloqueado para fazer o uso.\n                Após a ativação a concessionária tem o prazo de até 6h para atualização de lista.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Vendi meu veículo. O que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Devido o TAG ser intransferível é necessário realizar a solicitação de cancelamento do veículo através\n                do e-mail : "), _c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(", informando o motivo, a placa e o CPF.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Como eu faço se meu veículo for roubado?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Entre em contato com a Central de Relacionamento Move Mais. Solicite o bloqueio de seu TAG ou realize o\n                bloqueio direto pela sua conta Move Mais, acessando a Área "), _c('strong', [_vm._v("\"Ver Veículos\"")]), _vm._v(". Caso preferir, temos outras formas de\n                contato. Pelos telefones 4000 2901 (Capitais e Regiões Metropolitanas) e 0800 777 1022 (Demais Localidades) ou e-mail:\n                "), _c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(".\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Tenho dois equipamentos instalados no meu veículo (Move Mais e outro). Isso pode causar problema na\n              leitura dos TAGs ou confusão nos sistemas de captação do sinal?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                O sinal será captado por todos os leitores e o usuário deve ser cobrado em apenas um sistema.\n                O sistema da concessionária irá atribuir a cobrança ao TAG que foi lido primeiro e descartará a\n                leitura do segundo aparelho.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Após recarregar o TAG bloqueado por insuficiência de saldo, já posso voltar a utilizar normalmente ou é preciso esperar algum período para utilização?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Após recarregar o TAG bloqueado por insuficiência de saldo, você precisará aguardar o tempo de processamento\n                de acordo com cada instituição bancária. Após a confirmação do pagamento, o crédito é disponibilizado na sua conta\n                Move Mais e estará liberado para uso nos pedágios. O prazo é de até "), _c('strong', [_vm._v("6 horas")]), _vm._v(", tempo necessário para atualização nas concessionárias.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Meu TAG esta descolando. O que fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Neste caso entre em contato através do e-mail "), _c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(" enviando uma "), _c('strong', [_vm._v("foto")]), _vm._v(" do TAG,\n                informando o número da placa do veículo e o CPF.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Solicitei o cancelamento do meu TAG mas tenho saldo. O que acontece com o saldo?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                O saldo disponível fica vinculado ao seu contrato e não ao TAG, sendo assim compartilhado entre os veículos cadastrados.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Troquei de veículo, posso usar o mesmo TAG?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não! Nesse caso, você precisa realizar uma nova adesão em seu contrato, pois o TAG é intransferível.\n                Essa adesão é realizada em nosso site, acesse: "), _c('strong', [_vm._v("\"Minha Conta\"")]), _vm._v(" e na área de "), _c('strong', [_vm._v("\"Planos”")]), _vm._v("\n                clique em "), _c('strong', [_vm._v("\"Adicionar veículo\"")]), _vm._v(", para incluir o novo veículo em seu contrato.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Alterei minha placa para o modelo Mercosul. O que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Entre imediatamente em contato com a Move Mais, através do e-mail "), _c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(",\n                solicitando alteração da placa antiga e enviando o documento do veículo atualizado, junto com o CPF.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Como adicionar um novo veículo?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Basta acessar sua conta da Move Mais e clicar na opção "), _c('strong', [_vm._v("\"Adicionar Veículos\"")]), _vm._v(" e realizar a adesão.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Caso a cancela não abra o que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Deverá entrar em contato com a Central de Relacionamento através dos telefones 4000 2901 (Capitais e Regiões Metropolitanas)\n                e 0800 777 1022 (Demais Localidades), informando o ocorrido. Será analisado o motivo da não abertura automática da cancela.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              O Sistema de leitura dos TAGs pode ficar comprometido em dias de trânsito intenso?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não! A funcionalidade de leitura do seu TAG não será comprometida com volume maior ou menor de veículos.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Em caso de problemas com o TAG, o que devo fazer para substituí-lo?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Se seu TAG apresentar algum problema de leitura, você poderá solicitar uma análise à Central de Relacionamento\n                através do e-mail "), _c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(" ou pelos telefones 4000 2901 (Capitais e Regiões Metropolitanas) e\n                0800 777 1022 (Demais Localidades). Se for confirmada a falha, você será orientado sobre o procedimento de troca.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              O TAG pode ser removido e utilizado em outro veículo?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não! O TAG é intransferível pois é vinculado a placa, caso for removido o mesmo ficará inutilizável.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              O que acontece se eu não instalar o TAG no para-brisa do carro e usá-lo na mão quando estiver passando na cancela?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                O TAG possui um mecanismo de segurança que o inutiliza em caso de remoção ou tentativa de remoção do para-brisa.\n                Se for removido, é necessário adquirir um novo TAG. Se o TAG for utilizado de forma indevida (na mão, sem instalar no para-brisa),\n                o sistema identifica essa prática por meio de fotografias tiradas nas praças de pedágio e bloqueia a sua utilização,\n                fazendo assim com que a cancela não abra. Além disso, o cliente estará sujeito à multa por uso indevido do TAG.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Em quais situações o TAG poderá ser bloqueado?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                O TAG poderá ser bloqueado em caso de uso indevido, insuficiência de saldo ou nos casos de perda, roubo ou extravio.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Assim que ativar o TAG já posso passar pelo pedágio?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Não! Após o TAG ser ativado no sistema, é necessário aguardar um prazo de até "), _c('strong', [_vm._v("6 horas")]), _vm._v(" para poder\n                utilizar as praças de pedágios, pois as mesmas têm este prazo para consumirem as listas com as informações atuais do seu veículo.\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-line-red margin-b20"
  }, [_c('p', {
    staticClass: "bold upper"
  }, [_vm._v("cobrança")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Caso meu veículo seja guinchado o que fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Trabalhamos com as seguintes situações. "), _c('strong', [_vm._v("Guincho particular:")]), _vm._v(" caso o mesmo possua TAG, será atribuída a tarifa do pedágio ao mesmo.\n                "), _c('strong', [_vm._v("Guincho da concessionária:")]), _vm._v(" nesse caso é isento de tarifa pela ARTESP (Agência de Transporte do Estado de SP). A tarifa de\n                pedágio será cobrada pelo veículo. "), _c('strong', [_vm._v("Caso ambos os veículos possuirem TAG:")]), _vm._v(" nessa situação é necessário o cliente realizar\n                o bloqueio temporário antes da viagem, através de sua conta Move Mais ou via Central de Relacionamento. Não havendo bloqueio\n                temporário, a concessionária informa que a cobrança deve ser acordada entre o usuário e o Guincho. Caso haja o débito em ambos\n                os veículos, guincho e em seu TAG, será necessário o envio da solicitação de contestação, sendo analisado junto a concessionária.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              O que fazer se eu receber uma multa por evasão?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Entrar em contato com a Central de Relacionamento através do e-mail "), _c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v("\n                enviando uma cópia da autuação para analisarmos se a mesma será procedente ou improcedente.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Para caso de débito automático em conta, o titular deverá ser o mesmo que cadastrado na Move Mais?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Sim, o titular da conta corrente deve ser o mesmo da conta Move Mais.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Para caso de pagamento com Cartão de Crédito, o titular deverá ser o mesmo que cadastrado na Move Mais?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                O titular do cartão de crédito não precisa ser o mesmo cadastrado na Move Mais.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Tenho alguns veículos com TAG Move Mais. É possível recarregá-los separadamente?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Para facilitar a sua vida, aqui na Move Mais a recarga é feita por contrato e não por veículo cadastrado.\n                Assim, se você possui mais de um veículo no mesmo contrato, não precisa ficar se preocupando em fazer\n                recargas para cada um deles separadamente, pois os veículos desse contrato compartilham da recarga efetuada.\n                Para os casos em que o cliente desejar recarregar seus veículos de forma separada, é possível abrir novos\n                contratos e realizar recargas independentes para cada um deles.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Meu crédito é insuficiente e a viagem ainda não acabou. Como faço para recarregar créditos?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Você pode fazer a recarga através da sua contra acessando nosso site movemais.com ou através de nosso aplicativo.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Ao usar o serviço da Move Mais, eu pagarei a mesma tarifa praticada nos pedágios?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Sim, a tarifa é a mesma cobrada nos pedágios. Os valores são tabelados.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Se eu estiver inadimplente com o pagamento, serei bloqueado na passagem pelo pedágio? Ou serei multado por\n              evasão de pedágio?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Sim, será bloqueado. E, se não pagar o pedágio manualmente, será multado por evasão.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Quais são os valores disponíveis para recarga nos planos pré-pagos?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Nos planos Pré-pagos eu consigo colocar créditos do meu celular? O crédito é disponibilizado na hora?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              A Move Mais emite nota fiscal?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                A Move Mais é uma empresa de meios de pagamento eletrônico de pedágio, neste caso é feito a emissão apenas\n                de serviços prestados, no entanto a nota fiscal das passagens deve ser solicitada através das concessionárias\n                devido a mesma ser responsável pelas cobranças em seu TAG.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-b30"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "plan-line-green margin-b20"
  }, [_c('p', {
    staticClass: "bold upper"
  }, [_vm._v("serviços")])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Qual é a velocidade máxima nas praças de pedágio?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Para evitar acidentes e colisões nas praças de pedágio, respeite o limite de velocidade máxima\n                de "), _c('strong', [_vm._v("40 km/h")]), _vm._v(" sinalizado nas pistas de pedágio, sujeito à multa e pontos na carteira.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              A Move Mais tem transferência de saldo? Como faço para transferir meu saldo?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Nesse caso, basta acessar sua conta através do site movemais.com, e clicar na opção "), _c('strong', [_vm._v("\"Transferir Saldo\"")]), _vm._v(".\n                À cada transferência é cobrado o valor de "), _c('strong', [_vm._v("2%")]), _vm._v(".\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Esqueci minha senha. E agora?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Basta entrar em contato com nossa Central de Relacionamento através dos telefones: 4000 2901 (Capitais e Regiões Metropolitanas)\n                e 0800 777 1022 (Demais Localidades). Enviaremos uma recuperação através do e-mail cadastrado.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              A Move Mais tem uma cabine específica para passagens nos pedágios?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Nas praças de pedágio você deve usar as pistas com cobranças automáticas, que estarão devidamente sinalizadas.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Como faço para solicitar o cancelamento do meu plano Pré-pago?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                O cancelamento dos serviços Move Mais poderá ser feito através do e-mail "), _c('a', {
    attrs: {
      "href": "mailto:relacionamento@movemais.com"
    }
  }, [_vm._v("relacionamento@movemais.com")]), _vm._v(",\n                contendo CPF ou CNPJ, motivo do cancelamento e uma conta bancária de titularidade do cliente.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Sou pessoa física, solicitei o cancelamento do contrato mas tenho saldo disponível. O que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Nesse caso, realizamos o "), _c('strong', [_vm._v("estorno do saldo residual")]), _vm._v(" e o prazo para reembolso é de 60 dias à partir da data do cancelamento do contrato.\n                A taxa de cancelamento é de R$ 7,00.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              De quem é a responsabilidade pela manutenção das praças de pedágios e rodovias?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                A manutenção das rodovias é de responsabilidade da administradora responsável pela concessão, ou seja, a concessionária.\n                Qualquer dano causado ao patrimônio particular e público, incluindo as praças de pedágio, rodovias e outros, está sujeito\n                a eventuais penalidades na forma da legislação brasileira.\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "question-box margin-b20"
  }, [_c('h4', {
    staticClass: "bold-600"
  }, [_c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v("\n              Em caso de parada de veículo em fila o que devo fazer?\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "answer-box"
  }, [_c('p', {
    staticClass: "line-height-20"
  }, [_vm._v("\n                Se o veículo a sua frente parar, aguarde que o mesmo saia da pista automática e passe normalmente.\n                Mantenha sempre uma distância e velocidade segura do veículo à sua frente, para evitar colisões e acidentes.\n                Se após a passagem do veículo à sua frente, o semáforo continuar vermelho, aguarde orientação de algum funcionário da\n                concessionária, para evitar autuação por evasão de pedágio.\n              ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-0ee6bbfb!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/faq.vue
// module id = 2046
// module chunks = 1